<ng-container *ngIf="services.isMobile()">

    <div class="payments-header main-header">
        
        <nav class="navbar navbar-expand navbar-light topbar static-top" *ngIf="isPaymentAuth">
            <h1 class="header-logo">
                <svg xmlns="http://www.w3.org/2000/svg" width="100" height="52" viewBox="0 0 139 52">
                    <g id="Smart_Logo_with_Text" data-name="Smart Logo with Text" transform="translate(915 10555)">
                      <text id="SMART_BANK" data-name="SMART BANK" transform="translate(-852 -10535)" fill="#004A63" font-size="20"
                        font-family="Montserrat-ExtraBold, Montserrat" font-weight="800">
                        <tspan x="0" y="0">SMART</tspan>
                        <tspan x="0" y="26">BANK</tspan>
                      </text>
                      <g id="Rectangle_3516" data-name="Rectangle 3516" transform="translate(-915 -10555)" fill="none"
                        stroke="#004A63" stroke-width="12">
                        <rect width="52" height="52" stroke="none" />
                        <rect x="6" y="6" width="40" height="40" fill="none" />
                      </g>
                    </g>
                  </svg>
            </h1>
        </nav>
        
        <div class="d-flex paymentAccounts" *ngIf="!isPaymentAuth">
            <button class="btn-close"  clickable (click)="gotoTransfer()">
                <svg xmlns="http://www.w3.org/2000/svg" width="17.657" height="17.657" viewBox="0 0 17.657 17.657">
                    <g id="Group_12987" data-name="Group 12987" transform="translate(-5669.475 -484.975)">
                        <line id="Line_325" data-name="Line 325" x2="12" y2="12" transform="translate(5672.304 487.804)"
                        fill="none" stroke="#bebfbe" stroke-linecap="round" stroke-width="4" />
                        <line id="Line_326" data-name="Line 326" x1="12" y2="12" transform="translate(5672.304 487.804)"
                        fill="none" stroke="#bebfbe" stroke-linecap="round" stroke-width="4" />
                    </g>
                </svg>
            </button>
            <h2>
                {{ paymentOption }}
            </h2>
        </div>
    </div>
    
    <div class="payments-main-container">
        <router-outlet></router-outlet>
    </div>
</ng-container>

<ng-container *ngIf="services.isDesktop()">
<form class="MakeRelative">
    <div class="ShowLoading " *ngIf="loadSpinner">
     <div class="lds-roller MakeItMiddle">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    </div>
    </div>
    <div class="clearfix content">
    <div class="alert alert-danger" *ngIf="formOnLoadError">{{formOnLoadErrorMsg}}</div>
    <div *ngIf="!formOnLoadError">
    <div class="clearfix bi-reponsive" [ngClass]="{'display-border' : displayBorder}">
    <div class="form-group pb10">
    <div class="col-12  col-sm-12 col-md-12 group-default">
    <div #mainContainer id="mainContainer">
    <div class="form-group pb10 main-container payments-ws">
    <div class="col-12 col-xs-12 col-sm-12 col-md-12 res-pr-hide">
    <router-outlet></router-outlet>
    </div>
    </div>
    
    </div>
    </div>
    </div>
    </div>
    </div>
    </div>
    </form>
</ng-container>   
